import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.diskless');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-diskless',
template: templateSource || '',
    styles: [``],
})
export class PageKieraDisklessComponent implements OnInit {
    public list: any[] = [];
    public showAddModal: boolean = false;
    public newImage: any = { arch: 'AMD64', os: 'Ubuntu', name: '' };
    public archOptions: string[] = ['AMD64', 'ARM64'];
    public osOptions: string[] = ['Ubuntu', 'CentOS', 'Rocky'];
    public selectedKernel: File | null = null;
    public selectedInitrd: File | null = null;
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public uploadFileName: string = '';

    // Edit Modal
    public showEditModal: boolean = false;
    public editItem: any = null;

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("search");
        if (code === 200) {
            this.list = data.rows || [];
            this.sortList();
        }
        await this.service.render();
    }

    public onKernelSelected(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            this.selectedKernel = files[0];
        }
        this.service.render();
    }

    public onInitrdSelected(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            this.selectedInitrd = files[0];
        }
        this.service.render();
    }

    private uploadFile(url: string, formData: FormData, fileName: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.uploadFileName = fileName;
            this.uploadProgress = 0;
            this.service.render();
            const xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                    this.service.render();
                }
            });
            xhr.addEventListener('load', () => resolve());
            xhr.addEventListener('error', () => reject(new Error('Upload failed')));
            xhr.open('POST', url);
            const csrfCookie = document.cookie.split(';')
                .map((value: string) => value.trim())
                .find((value: string) => value.indexOf('KIERA_CSRF=') === 0);
            if (csrfCookie) xhr.setRequestHeader('X-KiERA-CSRF', csrfCookie.substring('KIERA_CSRF='.length));
            xhr.withCredentials = true;
            xhr.send(formData);
        });
    }

    public async addImage() {
        if (!this.newImage.name) return;
        this.uploading = true;
        this.uploadProgress = 0;
        this.uploadFileName = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(this.newImage) });
            if (code !== 200) { this.uploading = false; await this.service.render(); return; }
            const recordId = data.id;

            if (this.selectedKernel && recordId) {
                const formData = new FormData();
                formData.append('file', this.selectedKernel);
                await this.uploadFile(`/wiz/api/page.kiera.diskless/upload_kernel?id=${recordId}`, formData, this.selectedKernel.name);
            }

            if (this.selectedInitrd && recordId) {
                const formData = new FormData();
                formData.append('file', this.selectedInitrd);
                await this.uploadFile(`/wiz/api/page.kiera.diskless/upload_initrd?id=${recordId}`, formData, this.selectedInitrd.name);
            }

            this.showAddModal = false;
            this.newImage = { arch: 'AMD64', os: 'Ubuntu', name: '' };
            this.selectedKernel = null;
            this.selectedInitrd = null;
            await this.load();
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            this.uploadFileName = '';
            await this.service.render();
        }
    }

    public editImage(item: any) {
        this.editItem = { ...item };
        this.showEditModal = true;
        this.service.render();
    }

    public async saveEdit() {
        if (!this.editItem) return;
        const { code } = await wiz.call("update", { id: this.editItem.id, data: JSON.stringify(this.editItem) });
        if (code === 200) {
            this.showEditModal = false;
            this.editItem = null;
            await this.load();
        }
    }

    public downloadFile(id: number, fileType: string) {
        window.open(`/wiz/api/page.kiera.diskless/download?id=${id}&type=${fileType}`, '_blank');
    }

    public async deleteImage(id: number) {
        if (!confirm("Are you sure you want to delete this image?")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) await this.load();
    }

    public async hashRecreate(id: number) {
        const { code, data } = await wiz.call("hash_recreate", { id });
        if (code === 200) {
            const results = data.results || {};
            const msgs = Object.entries(results).map(([k, v]: any) => `${k}: ${v.md5}`);
            alert(`MD5 hash recreated:\n${msgs.join('\n')}`);
            await this.load();
        } else {
            alert(data?.message || 'Hash recreate failed');
        }
    }

    public formatSize(bytes: number): string {
        if (!bytes || bytes === 0) return '';
        const units = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + units[i];
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id' || field === 'kernel_size' || field === 'initrd_size') {
                return (Number(va) - Number(vb)) * dir;
            }
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraDisklessComponent;
